module.exports = __webpack_public_path__ + "img/Oval.c1375908.svg";